module.exports = __webpack_public_path__ + "img/symbol_0.94542a6d.png";